import { PlanningModeEnum } from "shared/enums/globalEnums";
import { FcrDEngagementFields } from "./initialFields";

export type PlanningName = string;

export enum TestTypeEnum {
  fcrN = "fcrN",
  fcrD = "fcrD",
  finlandAfrr = "finlandAfrr",
}

export interface BaseConfig {
  name: PlanningName;
  mode: PlanningModeEnum;
  durationInMinutes: number;
  // Optional bits used by both N/D:
  chronicleFilename?: string | null;
  activeDefault?: boolean; // default true if omitted
}

export enum FinlandAfrrInitialSocRestorationPowerEnum {
  positive = "positive",
  negative = "negative",
}

// SOC step
export interface SocConfig extends BaseConfig {
  mode: PlanningModeEnum.soc_management;
  targetSoc: number; // required for SOC
}

// FCR-N step: single engagement coming from initialData (min or max)
export type FcrNEngagementSource = "min" | "max";
export interface FcrNConfig extends BaseConfig {
  mode: PlanningModeEnum.fingrid_fcrn;
  engagementSource: FcrNEngagementSource; // which initial field to use
}

type FcrDEngagementFieldName = "fcrd_up_engagement" | "fcrd_down_engagement";

// AFRR step: initial soc restoration power

// FCR-D step: fixed up/down constants from config
export interface FcrDConfig extends BaseConfig {
  mode: PlanningModeEnum.fingrid_fcrd;
  engagementUpConst: number;
  engagementDownConst: number;
  defaultEngagementFieldMapping: [FcrDEngagementFields, FcrDEngagementFieldName | null];
}

export interface FinlandAfrrConfig extends BaseConfig {
  mode: PlanningModeEnum.fingrid_afrr;
  engagementUpConst: number | "default";
  engagementDownConst: number | "default";
  initialSocRestorationPower: FinlandAfrrInitialSocRestorationPowerEnum;
}

export type GenericPlanningConfig = SocConfig | FcrNConfig | FcrDConfig | FinlandAfrrConfig;

// The runtime value each planning item holds in the form
export interface GenericPlanningValue {
  active: boolean;
  start_date: Date;
  end_date: Date;
  mode: PlanningModeEnum;
  // Mode-specific hydrated values:
  targetSoc?: number | null;
  fcrn_engagement?: number | null; // FCR-N only
  fcrd_up_engagement?: number | null; // FCR-D only
  fcrd_down_engagement?: number | null; // FCR-D only
  afrr_engagement_up?: number | null; // AFRR only
  afrr_engagement_down?: number | null; // AFRR only
  chronicleFilename?: string | null;
  // TODO: Remove ?
  initialSocRestorationPower?: number | null;
}

export interface PlanningConfig {
  name: FcrNPlanningEnum;
  mode: PlanningModeEnum;
  durationInMinutes: number;
  fcrn_engagement: TrialEngagementEnum | null;
  targetSoc: number | null;
  chronicleFilename: string | null;
}

export enum FcrNPlanningEnum {
  planning_soc_1 = "planning_soc_1",
  planning_trial_1 = "planning_trial_1",
  planning_soc_2a = "planning_soc_2a",
  planning_trial_2a = "planning_trial_2a",
  planning_soc_2b = "planning_soc_2b",
  planning_trial_2b = "planning_trial_2b",
  planning_soc_3 = "planning_soc_3",
  planning_trial_3 = "planning_trial_3",
  planning_soc_1h = "planning_soc_1h",
  planning_trial_1h = "planning_trial_1h",
}

export enum TrialEngagementEnum {
  minimalOperationalPower = "minimalOperationalPower",
  maximalOperationalPower = "maximalOperationalPower",
}

export interface FcrNPlanningConfig {
  name: FcrNPlanningEnum;
  mode: PlanningModeEnum;
  durationInMinutes: number;
  fcrn_engagement: TrialEngagementEnum | null;
  targetSoc: number | null;
  chronicleFilename: string | null;
}
